export const translations = {
    // English (en)
    en: {
        siteTitle: "Zsolt Márku",
        nav: {
            logo: "Portfolio",
            home: "Home",
            about: "About",
            skills: "Skills",
            projects: "Projects",
            contact: "Contact",
        },
        home: {
            name: "Zsolt Márku",
            hello: "Hello, It's Me",
            tagline: "And I'm a " + `<span id="typed-effect"></span>`,
            description: `Welcome to my portfolio! <br> I'm a web developer passionate about building seamless web solutions and exploring the potential of artificial intelligence.`,
        },
        about: {
            title: "About " + `<span>Me</span>`,
            subtitle: "My journey and professional experiences (so far)",
            description: `I studied at the Faculty of Informatics at the University of Miskolc for two years, where I gained thorough knowledge in the field of computer science. <br>
During my studies, I discovered my passion for web development and programming, which has since defined my professional interests. <br><br>
My journey led me to the Netherlands, where I began my career at AMPCO Metal as a sawing machine operator. <br>
Within a short period, I was promoted to leadership positions, first as a Team Leader and then as a Warehouse Supervisor. <br>
In these roles, I learned how to lead teams, optimize processes, and ensure efficiency in a fast-paced industrial environment. <br><br>
Currently, I work at Arvato as a Warehouse Manager, where I oversee a larger team and supervise complex logistical operations. <br>
This role provides me with opportunities to further develop my strategic thinking and leadership skills. <br><br>
Meanwhile, my passion for IT and technology remains unchanged. <br>
I continuously expand my knowledge in web development, programming languages, as well as artificial intelligence and machine learning. <br>
This expertise enables me to combine technological innovations with my leadership experience to offer effective solutions to modern business challenges. <br><br>
I am ready to apply my knowledge and experience in new projects. <br>
Join me on this journey, and let’s explore the endless possibilities of web development, artificial intelligence, and technological advancement together! <br>`,
        },
        skills: {
            title: "My " + `<span>Skills</span>`,
            subtitle1: "Personal Skills",
            subtitle2: "Coding Skills",
            skillsData1: [
                { skill: "Responsibility", percentage: "95%" },
                { skill: "Leadership", percentage: "95%" },
                { skill: "Communication", percentage: "90%" },
                { skill: "Problem solving", percentage: "90%" },
                { skill: "Critical thinking", percentage: "85%" },
                { skill: "Motivation", percentage: "80%" },
                { skill: "Teamwork", percentage: "80%" },
                { skill: "Conflict management", percentage: "65%" },
            ],
            skillsData2: [
                { skill: "HTML", percentage: "90%", icon: "devicon-html5-plain colored" },
                { skill: "CSS", percentage: "85%", icon: "devicon-css3-plain colored" },
                { skill: "Bootstrap", percentage: "80%", icon: "devicon-bootstrap-plain-wordmark colored" },
                { skill: "Javascript", percentage: "80%", icon: "devicon-javascript-plain colored" },
                { skill: "MongoDB", percentage: "75%", icon: "devicon-mongodb-plain-wordmark colored" },
                { skill: "Node.JS", percentage: "70%", icon: "devicon-nodejs-plain-wordmark colored" },
                { skill: "React", percentage: "60%", icon: "devicon-react-original colored" },
                { skill: "Python (currently learning)", percentage: "40%", icon: "devicon-python-plain colored" },
            ],
        },
        portfolio: {
            title: "My " + `<span>Projects</span>`,
        },
        contact: {
            title: "Contact " + `<span>Me</span>`,
            namePlaceholder: "Full Name",
            emailPlaceholder: "Email Address",
            mobilePlaceholder: "Mobile Number",
            subjectPlaceholder: "Email Subject",
            messagePlaceholder: "Your Message",
            submit: "Submit",
        },
        footer: {
            text: "Copyright © %YEAR% | ZsMWebDev | Zsolt Márku",
        },
    },
    // Hungarian (hu)
    hu: {
        siteTitle: "Márku Zsolt",
        nav: {
            logo: "Portfólió",
            home: "Főoldal",
            about: "Rólam",
            skills: "Készségek",
            projects: "Projektek",
            contact: "Kapcsolat",
        },
        home: {
            name: "Márku Zsolt",
            hello: "Helló, ez én lennék",
            tagline: "És én egy " + `<span id="typed-effect"></span>` + " vagyok",
            description: "Üdvözöllek a portfóliómban! <br> Webfejlesztő vagyok, aki szenvedéllyel épít felhasználóbarát webes megoldásokat, és elkötelezett a mesterséges intelligencia lehetőségeinek felfedezése iránt.",
        },
        about: {
            title: "Röviden " + `<span>Rólam</span>`,
            subtitle: "Életutam és szakmai tapasztalataim (eddig)",
            description: `Két évig tanultam a Miskolci Egyetem Informatikai Karán, ahol alapos tudást szereztem a számítástechnika területén. <br>
Tanulmányaim során felfedeztem szenvedélyemet a webfejlesztés és a programozás iránt, amely azóta is meghatározza szakmai érdeklődésemet. <br><br>
Az utam Hollandiába vezetett, ahol az AMPCO Metal- nál kezdtem karrieremet fűrészgép- kezelőként. <br>
Rövid időn belül vezetői pozíciókba léptem elő, először Team Leader, majd Warehouse Supervisor szerepben. <br>
Ezekben a pozíciókban megtanultam, hogyan irányítsak csapatokat, optimalizáljam a folyamatokat, és biztosítsam a hatékonyságot egy gyors tempójú ipari környezetben. <br><br>
Jelenleg az Arvatónál dolgozom, mint Warehouse Manager, ahol egy nagyobb csapat irányításával és komplex logisztikai műveletek felügyeletével foglalkozom. <br>
Ez a szerep lehetőséget nyújt számomra, hogy tovább fejlesszem stratégiai gondolkodásomat és vezetői képességeimet. <br><br>
Mindeközben az informatika és a technológia iránti szenvedélyem változatlan maradt. <br>
Folyamatosan bővítem tudásomat a webfejlesztés, a programozási nyelvek, valamint a mesterséges intelligencia és gépi tanulás területén. <br>
Ez a tudás lehetővé teszi számomra, hogy ötvözzem a technológiai innovációkat a vezetői tapasztalataimmal, és hatékony megoldásokat kínáljak a modern üzleti kihívásokra. <br><br>
Készen állok arra, hogy tudásomat és tapasztalataimat új projektekben kamatoztassam. <br>
Csatlakozz hozzám ezen az úton, és fedezzük fel együtt a webfejlesztés, a mesterséges intelligencia és a technológiai fejlődés végtelen lehetőségeit! <br>`,
        },
        skills: {
            title: "Saját " + `<span>Képességeim és Készségeim</span>`,
            subtitle1: "Saját Képességeim",
            subtitle2: "Saját Készségeim",
            skillsData1: [
                { skill: "Felelősség", percentage: "95%" },
                { skill: "Vezetői képességek", percentage: "95%" },
                { skill: "Kommunikáció", percentage: "90%" },
                { skill: "Problémamegoldás", percentage: "90%" },
                { skill: "Kritikus gondolkodás", percentage: "85%" },
                { skill: "Motiváció", percentage: "80%" },
                { skill: "Csapatmunka", percentage: "80%" },
                { skill: "Konfliktuskezelés", percentage: "65%" },
            ],
            skillsData2: [
                { skill: "HTML", percentage: "90%", icon: "devicon-html5-plain colored" },
                { skill: "CSS", percentage: "85%", icon: "devicon-css3-plain colored" },
                { skill: "Bootstrap", percentage: "80%", icon: "devicon-bootstrap-plain-wordmark colored" },
                { skill: "Javascript", percentage: "80%", icon: "devicon-javascript-plain colored" },
                { skill: "MongoDB", percentage: "75%", icon: "devicon-mongodb-plain-wordmark colored" },
                { skill: "Node.JS", percentage: "70%", icon: "devicon-nodejs-plain-wordmark colored" },
                { skill: "React", percentage: "60%", icon: "devicon-react-original colored" },
                { skill: "Python (jelenleg tanulom)", percentage: "40%", icon: "devicon-python-plain colored" },
            ],
        },
        portfolio: {
            title: "Saját " + `<span>Projektjeim</span>`,
        },
        contact: {
            title: "Keress " + `<span>Meg</span>`,
            namePlaceholder: "Teljes név",
            emailPlaceholder: "Email cím",
            mobilePlaceholder: "Telefonszám",
            subjectPlaceholder: "Email tárgya",
            messagePlaceholder: "Üzeneted",
            submit: "Küldés",
        },
        footer: {
            text: "Szerzői jog © %YEAR% | ZsMWebDev | Márku Zsolt",
        },
    },
    // Dutch (nl)
    nl: {
        siteTitle: "Zsolt Márku",
        nav: {
            logo: "Portfolio",
            home: "Home",
            about: "Over Mij",
            skills: "Vaardigheden",
            projects: "Projecten",
            contact: "Contact",
        },
        home: {
            name: "Zsolt Márku",
            hello: "Hallo, Ik ben het",
            tagline: "En ik ben een " + `<span id="typed-effect"></span>`,
            description: `Welkom op mijn portfolio! <br> Ik ben een webontwikkelaar met een passie voor het bouwen van gebruiksvriendelijke weboplossingen en het verkennen van de mogelijkheden van kunstmatige intelligentie.`,
        },
        about: {
            title: "Over " + `<span>Mij</span>`,
            subtitle: "Mijn levenspad en professionele ervaringen (tot nu toe)",
            description: `Ik heb twee jaar gestudeerd aan de Faculteit Informatica van de Universiteit van Miskolc, waar ik grondige kennis heb opgedaan op het gebied van computerwetenschappen. <br>
Tijdens mijn studie ontdekte ik mijn passie voor webontwikkeling en programmeren, wat sindsdien mijn professionele interesse heeft bepaald. <br><br>
Mijn reis bracht me naar Nederland, waar ik mijn carrière begon bij AMPCO Metal als zaagmachine-operator. <br>
Binnen korte tijd werd ik gepromoveerd naar leidinggevende functies, eerst als Teamleider en daarna als Magazijnsupervisor. <br>
In deze rollen leerde ik hoe ik teams moet leiden, processen kan optimaliseren en efficiëntie kan waarborgen in een snel veranderende industriële omgeving. <br><br>
Momenteel werk ik bij Arvato als Magazijnmanager, waar ik een groter team aanstuur en complexe logistieke operaties overzie. <br>
Deze rol biedt mij de mogelijkheid om mijn strategisch denkvermogen en leiderschapsvaardigheden verder te ontwikkelen. <br><br>
Ondertussen is mijn passie voor IT en technologie onveranderd gebleven. <br>
Ik breid voortdurend mijn kennis uit op het gebied van webontwikkeling, programmeertalen, evenals kunstmatige intelligentie en machine learning. <br>
Deze expertise stelt mij in staat om technologische innovaties te combineren met mijn leidinggevende ervaring en effectieve oplossingen te bieden voor moderne zakelijke uitdagingen. <br><br>
Ik ben klaar om mijn kennis en ervaring in nieuwe projecten toe te passen. <br>
Sluit je aan bij mijn reis en laten we samen de eindeloze mogelijkheden van webontwikkeling, kunstmatige intelligentie en technologische vooruitgang ontdekken! <br>`,
        },
        skills: {
            title: "Mijn " + `<span>Competenties en Vaardigheden</span>`,
            subtitle1: "Mijn Competenties",
            subtitle2: "Mijn Vaardigheden",
            skillsData1: [
                { skill: "Verantwoordelijkheid", percentage: "95%" },
                { skill: "Leiderschap", percentage: "95%" },
                { skill: "Communicatie", percentage: "90%" },
                { skill: "Probleemoplossend vermogen", percentage: "90%" },
                { skill: "Kritisch denken", percentage: "85%" },
                { skill: "Motivatie", percentage: "80%" },
                { skill: "Teamwerk", percentage: "80%" },
                { skill: "Conflictbeheer", percentage: "65%" },
            ],
            skillsData2: [
                { skill: "HTML", percentage: "90%", icon: "devicon-html5-plain colored" },
                { skill: "CSS", percentage: "85%", icon: "devicon-css3-plain colored" },
                { skill: "Bootstrap", percentage: "80%", icon: "devicon-bootstrap-plain-wordmark colored" },
                { skill: "Javascript", percentage: "80%", icon: "devicon-javascript-plain colored" },
                { skill: "MongoDB", percentage: "75%", icon: "devicon-mongodb-plain-wordmark colored" },
                { skill: "Node.JS", percentage: "70%", icon: "devicon-nodejs-plain-wordmark colored" },
                { skill: "React", percentage: "60%", icon: "devicon-react-original colored" },
                { skill: "Python (momenteel aan het leren)", percentage: "40%", icon: "devicon-python-plain colored" },
            ],
        },
        portfolio: {
            title: "Mijn " + `<span>Projecten</span>`,
        },
        contact: {
            title: "Contact " + `<span>Mij</span>`,
            namePlaceholder: "Volledige naam",
            emailPlaceholder: "E-mailadres",
            mobilePlaceholder: "Telefoonnummer",
            subjectPlaceholder: "Onderwerp van de e-mail",
            messagePlaceholder: "Uw bericht",
            submit: "Verzenden",
        },
        footer: {
            text: "Auteursrecht © %YEAR% | ZsMWebDev | Zsolt Márku",
        },
    },
};
